import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="smooth-scroll"
export default class extends Controller {
  static values = {
    offset: {
      type: Number,
      default: 150
    }
  }

  smoothScroll(event) {
    event.preventDefault();
    const targetId = event.target.getAttribute("href")
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      const offset = Number(this.offsetValue);
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
}
